var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"pagination"},[_c('el-pagination',{attrs:{"layout":"prev, pager, next","page-size":_vm.pageSize,"total":_vm.total},on:{"current-change":_vm.currentChange}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }